import api from "../../../api/api";

export const getStageList = (page: number, params: any = {}) => {
  return api.get("/crm/v1/stage-master/", {
    params: {
      page,
      ...params,
    },
  });
};

export interface CreateStagePayload {
  stage_name: string;
  description?: string;
  is_active: boolean;
}

export const createStage = (data: CreateStagePayload) => {
  return api.post("/crm/v1/stage-master/", data);
};
export const getStageById = (id: number) => {
  return api.get(`/crm/v1/stage-master/${id}/`);
};


export const updateStage = (id: number, data: {
  stage_name: string;
  description?: string;
  is_active: boolean;
}) => {
  return api.put(`/crm/v1/stage-master/${id}/`, data);
};
export const getQuoteMasterList = () => {
  return api.get("/crm/v1/quote-master/");
};
